import { gql } from "@apollo/client";

const Fragments = {
  partnerData: gql`
    fragment partnerData on Partner {
      partnerId
      partnerTypeId
      uniqueID
      partnerCode
      partnerName
      firstName
      lastName
      identityCardNo
      issuedBy
      identityDocumentIssueDate
      identityDocumentExpireDate
      identityDocumentTypeId
      citizenshipId
      nationalityId
      email
      phoneNumber
      phoneCountryCode
      contactPersonName
      contactPersonUniqueID
      chContactPersonId
      districtId
      city {
        id
        name
      }
      street
      streetNumber
      buildingNumber
      stairNumber
      floorNumber
      flatNumber
      zipCode
      fullAddress
      activityFieldId
      usageTypeId
      drivingLicenseReleaseDate
      validationMoment
      masterPartnerValidationMoment
      agreesWithPersonalDataUse
      isSystem
      masterPartnerId
      chPartnerId
    }
  `,
  legalPartner: gql`
    fragment legalPartner on LegalPartnerOutput {
      page
      pageSize
      totalCount
      totalPages
      values {
        partnerId
        partnerTypeId
        uniqueId
        name
        legalForm
      }
    }
  `,
  individualPartner: gql`
    fragment individualPartner on IndividualPartnerOutput {
      page
      pageSize
      totalCount
      totalPages
      values {
        partnerId
        partnerTypeId
        uniqueId
        partnerName
        fullName
        citizenship
        nationality
        idSeriesAndNumber
        birthDate
        country
        county
        city
      }
    }
  `
};

export default Fragments;
